var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagramIcon = function SvgInstagramIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 33 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    d: "M24.47 9.69a1.694 1.694 0 0 1-1.696-1.685 1.695 1.695 0 0 1 3.39 0c0 .929-.76 1.686-1.694 1.686m-8.226 13.39c-3.841 0-6.968-3.123-6.968-6.964 0-3.84 3.127-6.964 6.968-6.964s6.967 3.123 6.967 6.964-3.125 6.965-6.967 6.965M23.41.009H9.587C4.411.008.932 3.649.932 9.07V22.08c0 5.42 3.479 9.062 8.655 9.062h13.82c5.18 0 8.66-3.643 8.66-9.062V9.07c0-5.421-3.48-9.062-8.657-9.062",
    clipRule: "evenodd"
  })));
};
export default SvgInstagramIcon;